import { trackAPIMethods } from '../tracking';
import { createModifier } from './modifier';

export const modifyContent = (init, location, modifierObject) => {
	const modifier = createModifier(init, location, modifierObject);
	modifier.apply();

	trackAPIMethods(init, { methodType: 'modifyContent', location });
};
